export default "__VITE_ASSET__CZmlNrlc__"